
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class EditReleasesLoader extends Vue {}
